import { BlockId, blockNames, BlockType, SolutionInfo, SupportType } from '../types';

export function createBreadcrumbsSolutionInfo(data: {
  isHomeCategory: boolean;
  id: string;
  index: number;
  name?: string;
}): SolutionInfo {
  return {
    text: data.name,
    block_id: BlockId.Breadcrumbs,
    block_name: blockNames[BlockId.Breadcrumbs],
    block_position: 1,
    block_type: BlockType.Breadcrumbs,
    block_details: [
      {
        support_type: data.isHomeCategory ? SupportType.AllHelpTopics : SupportType.Category,
        support_id: data.isHomeCategory ? null : data.id,
        support_position: data.index + 1,
      },
    ],
  };
}
